module.exports = __webpack_public_path__ + "img/header-diamondJewelry070Carat.2f4e790.jpg";